import {
  CREATE_WIZARD_SEARCH_MAP,
  DATA_ELEMENT_TYPE_TO_LABEL,
  HELPER_DOCS,
  HTML_REPORT_FIELD_NAMES,
  ONE_ONE_CALCULATION_EXPRESSIONS,
  STUDIO_DATA_TYPE,
  CRM_DATA_ENGINE_DIMENSIONS,
  CRM_DATA_ENGINE_METRICS,
  NAVIGATION_ACTIONS
} from "@/static/global-variables";
import mixin from "@/utils/global-mixin";
import { LIST_COMPONENTS } from "@/static/config-list-components";
import { v4 as uuidv4 } from "uuid";
import store from "@/store";
import iconsUri from "@/views/drag-drop-pages/components/utils/icons-uri";
import { QUERIES } from "@/static/queries";
import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
import i18n from "@/plugins/i18n";

export default {
  findMissingVeevaMessages(msgResp, list) {
    let names = msgResp.map(msg => {
      return msg.Name;
    });

    return list.filter(function(vMsg) {
      return !names.includes(vMsg.name);
    });
  },
  reformatMessages(messages, veevaMessages, userLocale) {
    let output = {};
    messages.forEach(function(msg) {
      output[msg.Name] = msg;
    });
    // add missing messages
    for (const vm of veevaMessages) {
      if (!output[vm.name]) {
        output[vm.name] = {
          Name: vm.name,
          Text_vod__c: vm.name,
          Category_vod__c: vm.category,
          Language_vod__c: userLocale
        };
      }
    }

    return output;
  },
  reformatRecordTypes(rawTypes, labels) {
    const records = rawTypes.filter(e => {
      const mapping = CREATE_WIZARD_SEARCH_MAP[e.DeveloperName];
      let showRecord = true;
      if (mapping) {
        if (mapping.object) {
          // filter record if it has no label
          // object does not exists or the user has no access to that object in SF
          showRecord = Boolean(labels.get(mapping.object));
        }
        if (mapping.contentType) {
          e.type = mapping.contentType;
        }
      }
      return showRecord;
    });
    return records.map(record => {
      return {
        text: record.Name,
        value: {
          devName: record.DeveloperName,
          id: record.Id,
          type: record.type
        }
      };
    });
  },
  getRecordTypeObject(type) {
    if (
      type.toLowerCase() ===
        CREATE_WIZARD_SEARCH_MAP.Territory_Insights_vod.contentType.toLowerCase() ||
      type.toLowerCase() ===
        CREATE_WIZARD_SEARCH_MAP.Territory_Feedback_vod.contentType.toLowerCase()
    ) {
      return undefined;
    }
    const map = new Map(Object.entries(CREATE_WIZARD_SEARCH_MAP));
    let mapping;
    map.forEach(value => {
      if (type === value.contentType) {
        mapping = value;
      }
    });
    return mapping;
  },
  getObjectFromContentType(type) {
    if (
      type.toLowerCase() ===
        CREATE_WIZARD_SEARCH_MAP.Territory_Insights_vod.contentType.toLowerCase() ||
      type.toLowerCase() ===
        CREATE_WIZARD_SEARCH_MAP.Territory_Feedback_vod.contentType.toLowerCase()
    ) {
      return undefined;
    }
    const map = new Map(Object.entries(CREATE_WIZARD_SEARCH_MAP));
    let object;
    map.forEach(value => {
      if (type === value.contentType) {
        object = value.object;
      }
    });
    return object;
  },
  filterTypes(recordTypes, describeObject) {
    // Get ordered list of content type
    const map = new Map(Object.entries(CREATE_WIZARD_SEARCH_MAP));
    const idToLabelMap = new Map(
      describeObject.recordTypeInfos.map(object => {
        return [
          object.recordTypeId,
          { name: object.name, available: object.available }
        ];
      })
    );
    const order = [];
    map.forEach(value => {
      if (!order.includes(value.contentType)) {
        order.push(value.contentType);
      }
    });
    // Sort content types
    recordTypes.sort(function(a, b) {
      return order.indexOf(a.value.type) - order.indexOf(b.value.type);
    });
    // Remove duplicate content types
    const uniqueTypes = [];
    return recordTypes.filter(element => {
      const isDuplicate = uniqueTypes.includes(element.value.type);
      if (
        !isDuplicate &&
        element.value.type != null &&
        idToLabelMap.get(element.value.id).available
      ) {
        uniqueTypes.push(element.value.type);
        return true;
      }
      return false;
    });
  },
  camelCase(str) {
    return str
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
  },
  getVeevaMessageFromTemplate(msgTemplate, value, defaultPrefix) {
    if (msgTemplate) {
      return msgTemplate.replace("{0}", value);
    }

    return defaultPrefix + value;
  },
  appHasDeployments(apps, appId) {
    let targetApp = apps.find(app => {
      return app.uuid === appId;
    });

    return !!targetApp.deployments;
  },
  addDeploymentsDataToApp(apps, appId, deployments) {
    return apps.map(app => {
      if (app.uuid === appId) {
        app.deployments = deployments;
      }

      return app;
    });
  },
  addDeploymentsToAllApps(apps, appIds, deployments) {
    let mapping = {};
    let clone = apps.concat();
    appIds.forEach(id => {
      mapping[id] = deployments.filter(d => {
        return d.Studio_Id_vod__c === id;
      });

      let found = clone.find(app => app.uuid === id);

      if (found) {
        found.deployments = mapping[id];
      }
    });

    return clone;
  },
  pruneSFRecords(records) {
    return records.map(record => {
      let output = {};
      Object.keys(record).forEach(key => {
        if (key.includes("vod") || key.toLowerCase() === "Id".toLowerCase()) {
          output[key] = record[key];
        }
      });

      return output;
    });
  },
  getFormattedFieldNames(obj, keys) {
    let output = [];
    keys.forEach(key => {
      let config = {
        key: key,
        label: obj[key]
      };

      if (key === HTML_REPORT_FIELD_NAMES.Studio_Version_vod__c) {
        config.class = "text-center";
      }

      if (key === HTML_REPORT_FIELD_NAMES.Phone_vod__c) {
        config.class = "text-center";
        config.link = HELPER_DOCS.phoneLink;
      }

      if (key === HTML_REPORT_FIELD_NAMES.Platform_vod__c) {
        config.class = "platform-col";
        config.link = HELPER_DOCS.platformLink;
      }

      if (key === HTML_REPORT_FIELD_NAMES.RecordType) {
        config.class = "platform-col";
        config.link = HELPER_DOCS.deployContentTypeLink;
      }

      if (key === HTML_REPORT_FIELD_NAMES.Profile_Name_vod__c) {
        config.class = "prof-name-col";
      }

      output.push(config);
    });

    return output;
  },
  getDSFieldExpressions(fields) {
    let output = [];

    for (const [key, value] of Object.entries(fields)) {
      if (value.expression) {
        const exp = this.findConfigExp(value);
        output.push({
          id: uuidv4(),
          label: key,
          userLabel: value.userLabel || key,
          dataType: value.dataType,
          expType: exp.expType,
          configExp: exp.configExp,
          value: value
        });
      }
    }
    return output;
  },
  getDSFields(fields) {
    let output = [];

    for (const [key, value] of Object.entries(fields)) {
      if (!value.expression) {
        output.push({
          id: uuidv4(),
          name: key,
          label: value.label,
          userLabel: value.userLabel || value.label,
          dataType: value.dataType,
          expType: value.expType
        });
      }
    }
    return output;
  },
  findConfigExp(field) {
    for (const [key, value] of Object.entries(LIST_COMPONENTS)) {
      if (value.type === field.type) {
        return {
          expType: key,
          configExp: value
        };
      }
    }
  },
  getExpressionTypes(deType) {
    let output = [];
    const messages = store.getters.messages;

    const mapping = {
      DATA_EL_ONE_FOR_ONE: ONE_ONE_CALCULATION_EXPRESSIONS
    };
    const types = mapping[deType];
    if (types) {
      output = types.map(t => {
        return {
          label: messages[t].Text_vod__c,
          expType: t,
          id: uuidv4()
        };
      });
    } else {
      output = [];
    }
    return output;
  },
  formatExpressionFields(fields, formattedFields) {
    formattedFields = formattedFields || {};

    fields.forEach(item => {
      formattedFields[item.userLabel || item.label] =
        item.confExpression || item.value;
    });

    return formattedFields;
  },
  formatDSFields(fields) {
    let output = {};

    fields.forEach(item => {
      output[item.name] = {
        dataType: item.dataType,
        label: item.label,
        userLabel: item.userLabel,
        expType: item.expType
      };
    });

    return output;
  },
  findDataElementById(elements, id) {
    return elements.find(e => {
      return e.id === id;
    });
  },
  getDataElementLabel(type) {
    return DATA_ELEMENT_TYPE_TO_LABEL[type.replace("DATA_EL_", "")];
  },
  getModalSubtitle(type) {
    return `${i18n.t(this.getDataElementLabel(type) + "Subtitle")}`;
  },
  findAppByAppId(apps, appId) {
    return apps.find(app => {
      return app.uuid === appId;
    });
  },
  hasVeevaMsgDataElement(app) {
    if (!app.dataElements) {
      return false;
    }
    const des = Object.values(app.dataElements);

    return !!des.find(de => {
      return de.type === "DATA_EL_VEEVA_MESSAGES";
    });
  },
  getBridgeObjectIds(appType, userId, testRecord, contextAccount) {
    const mapping = {
      Account: {
        Account: "",
        User: "",
        TSF_vod__c: "",
        HTML_Report_vod__c: ""
      },
      Account_Plan_vod__c: {
        Account: "",
        User: "",
        Account_Plan_vod__c: "",
        HTML_Report_vod__c: ""
      },
      Order_vod__c: {
        Account: "",
        User: "",
        TSF_vod__c: "",
        HTML_Report_vod__c: "",
        Order_vod__c: ""
      },
      Inventory_Monitoring_vod__c: {
        Account: "",
        User: "",
        TSF_vod__c: "",
        HTML_Report_vod__c: "",
        Inventory_Monitoring_vod__c: ""
      },
      EM_Speaker_vod__c: {
        User: "",
        HTML_Report_vod__c: "",
        EM_Speaker_vod__c: ""
      },
      Call2_vod__c: {
        Call2_vod__c: "",
        HTML_Report_vod__c: ""
      }
    };

    let output = {};
    const objName = this.getObjectFromContentType(appType);

    if (objName) {
      output = mapping[objName];

      // Assigning Account at last because the other objects has dedicated field
      if (output.Call2_vod__c !== undefined) {
        output.Call2_vod__c = testRecord;
      } else if (output.Account_Plan_vod__c !== undefined) {
        output.Account_Plan_vod__c = testRecord;
      } else if (output.Order_vod__c !== undefined) {
        output.Order_vod__c = testRecord;
      } else if (output.Inventory_Monitoring_vod__c !== undefined) {
        output.Inventory_Monitoring_vod__c = testRecord;
      } else if (output.EM_Speaker_vod__c !== undefined) {
        output.EM_Speaker_vod__c = testRecord;
      } else {
        output.Account = testRecord;
      }
    }

    output.User = userId;
    output.Account = contextAccount;
    output.Test_Record = testRecord;
    output.App_Type = appType;

    return output;
  },
  translatedExpressionLabel(expression) {
    if (expression && expression.messageKey) {
      const message = store.getters.messages[expression.messageKey];
      if (message) {
        expression.label = message.Text_vod__c;
      } else {
        expression.label = expression.messageKey;
      }
    }
    return expression;
  },
  getTranslatedLabelsForExpressions(expressions) {
    let output = [];

    if (expressions) {
      if (Array.isArray(expressions)) {
        const messages = store.getters.messages;

        output = expressions.map(e => {
          e.label = messages[e.messageKey]
            ? messages[e.messageKey].Text_vod__c
            : e.messageKey;
          return e;
        });
      } else {
        for (let [, value] of Object.entries(expressions)) {
          value = this.getTranslatedLabelsForExpressions(value);
        }
        return expressions;
      }
    }

    return output;
  },
  findFieldFLS(sfDescribe, fieldName) {
    let output = {
      hasRead: false,
      hasEdit: false
    };

    if (sfDescribe) {
      let field = sfDescribe.fields.find(f => {
        return f.name.toLowerCase() === fieldName.toLowerCase();
      });

      if (field) {
        output.hasRead = true;

        if (field.updateable) {
          output.hasEdit = true;
        }
      }
    }

    return output;
  },
  isComparableType(type) {
    return (
      type === "string" ||
      type === "number" ||
      type === "date" ||
      type === "datetime"
    );
  },
  getOpsForAll(operators) {
    return operators.filter(op => {
      return [
        "equal",
        "not equal",
        "not_equal",
        "is null",
        "is_null",
        "is not null",
        "is_not_null"
      ].includes(op.value.value);
    });
  },
  getOpsForComparable(operators) {
    return operators.filter(op => {
      return [
        "gt",
        "greater_than",
        "gte",
        "greater_than_or_equal",
        "lt",
        "less_than",
        "lte",
        "less_than_or_equal",
        "between"
      ].includes(op.value.value);
    });
  },
  getOpsForStringList(operators) {
    return operators.filter(op => {
      return op.value.value === "in";
    });
  },
  mergeMetadataIntoFields(fields, metadataRecords, isCRMModal) {
    let filtered = fields.filter(field => {
      return metadataRecords.find(f => {
        return f.QualifiedApiName === field.name;
      });
    });

    return filtered.map(field => {
      const fieldMeta = metadataRecords.find(f => {
        return f.QualifiedApiName === field.name;
      });

      const dataType = fieldMeta ? fieldMeta.DataType : "";
      const description = fieldMeta ? fieldMeta.Description : "";

      return {
        name: field.name,
        label: field.label,
        type: field.type,
        hideFromWhereClause: isCRMModal ? field.hideFromWhereClause : null,
        hideFromMultiSelect: field.hideFromMultiSelect,
        originalType: field.originalType,
        dataType,
        description
      };
    });
  },
  getStandardLocalFormat(locale) {
    let tokens = locale.split("_");
    if (Array.isArray(tokens) && tokens.length > 1) {
      return `${tokens[0]}-${tokens[1]}`;
    }

    return "en-US";
  },
  findExpressionLabel(exp) {
    if (!exp || !Object.keys(exp).length) {
      return "";
    }
    let output;
    const type = exp.type.toLowerCase();
    const messages = store.getters.messages;
    const currentContent = store.getters.currentContent;

    if (type === "static") {
      output = exp.dataType === "string" ? `"${exp.value}"` : exp.value;
    } else {
      let msgKey;
      for (const [key, value] of Object.entries(LIST_COMPONENTS)) {
        if (value.type.toLowerCase() === type) {
          msgKey = key;
          break;
        }
      }

      if (msgKey) {
        output = msgKey.includes("EXP_")
          ? mixin.methods.getMessageText(messages[msgKey])
          : i18n.t(msgKey);
      } else {
        let elemId = exp.referToElem || exp.dataElement;
        if (
          exp.type &&
          (exp.type.toLowerCase() === "local field" ||
            exp.type.toLowerCase() === "singleton field") &&
          elemId
        ) {
          const de = currentContent.dataElements[elemId];
          output = de ? `${de.name} -> ${exp.field}` : "";
        } else {
          output = exp.value || exp.field;
        }
      }
    }
    return output;
  },

  reformatForName(messages) {
    return messages.map(msg => {
      return {
        description: msg.Description_vod__c,
        label: msg.Name,
        category: msg.Category_vod__c
      };
    });
  },
  hasInvalidElements(list) {
    return !!list.find(item => !item.isValid);
  },
  escapeSingleQuotes(input) {
    return input ? input.replace(/'/g, "\\'") : "";
  },
  isNitroStringType(nType) {
    return nType.includes("char") || nType.includes("text");
  },
  isNitroNumberType(nType) {
    return (
      nType.includes("int") ||
      nType.includes("decimal") ||
      nType.includes("numeric") ||
      nType.includes("float") ||
      nType.includes("double") ||
      nType.includes("real")
    );
  },
  isNitroDateType(nType) {
    return nType.includes("date");
  },
  isNitroBooleanType(nType) {
    return nType.includes("bool");
  },
  isNitroDateTimeType(nType) {
    return nType.includes("timestamp");
  },
  convertNitroColumnTypeToStudioType(nitroType) {
    const nType = nitroType.toLowerCase();
    if (this.isNitroStringType(nType)) {
      return STUDIO_DATA_TYPE.STRING;
    }
    if (this.isNitroNumberType(nType)) {
      return STUDIO_DATA_TYPE.NUMBER;
    }
    if (this.isNitroDateType(nType)) {
      return STUDIO_DATA_TYPE.DATE;
    }
    if (this.isNitroBooleanType(nType)) {
      return STUDIO_DATA_TYPE.BOOLEAN;
    }
    if (this.isNitroDateTimeType(nType)) {
      return STUDIO_DATA_TYPE.DATE_TIME;
    }
    return "";
  },
  reformatNitroTable(tables) {
    return tables.map(t => {
      const reformattedColumns = t.columns.map(c => {
        const reformattedTypes = this.convertNitroColumnTypeToStudioType(
          c.type
        );
        return {
          name: c.name,
          label: c.label || c.name,
          originalType: c.type,
          type: reformattedTypes,
          dataType: c.type
        };
      });

      const columns = reformattedColumns.filter(c => {
        return c.type !== "";
      });

      return {
        label: t.label,
        originalName: t.name,
        name: t.tableName,
        columns
      };
    });
  },
  extractCommonSettings(configs, urlField, versionField) {
    let output = {
      url: "",
      version: ""
    };
    const veevaCommon = configs.find(c => {
      return c.name === "Veeva_Common_vod__c";
    });

    if (veevaCommon) {
      output.url = veevaCommon.data[urlField];
      output.version = veevaCommon.data[versionField];
    }

    return output;
  },

  extractCRMServerInfo(configs) {
    let output = {
      url: "",
      version: ""
    };
    const veevaCommon = configs.find(c => {
      return c.name === "Veeva_Common_vod__c";
    });

    if (veevaCommon) {
      output.url = veevaCommon.data["Veeva_Server_vod__c"];
      output.version = veevaCommon.data["Veeva_Version_vod__c"];
    }

    return output;
  },
  extractTerritorySettings(configs, urlField, versionField) {
    let output = {
      url: "",
      version: ""
    };
    const territorySetting = configs.find(c => {
      return c.name === "Territory_Settings_vod__c";
    });

    if (territorySetting) {
      output.url = territorySetting.data[urlField];
      output.version = territorySetting.data[versionField];
    }

    return output;
  },
  formatNitroResponseForPreview(data) {
    let output = {
      success: true,
      record_count: data.num_records
    };
    output[data.object] = data.records;
    return output;
  },
  findFieldByName(fields, name) {
    return fields.find(field => field.name === name);
  },
  getIconClass(icon) {
    if (!icon) {
      return "";
    }

    let formatted = icon.name.replaceAll("_", "-");
    return `slds-icon-${icon.category}-${formatted}`;
  },
  getIconPath(iconObj) {
    if (!iconObj || !iconObj.category) {
      return "";
    }

    let categoryMap = {
      standard: iconsUri.getStandardUrl,
      utility: iconsUri.getUtilityUrl,
      custom: iconsUri.getCustomUrl
    };

    const f = categoryMap[iconObj.category];

    return typeof f === "function" ? f.call(iconsUri, iconObj.name) : "";
  },
  getDeploymentTableFLS(objectDescribe) {
    const objName = QUERIES.htmlReport.object;

    return {
      platformFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Platform_vod__c
      ),
      statusFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Status_vod__c
      ),
      statusDetailsFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Failure_Msg_vod__c
      ),
      reportProfileIdFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Profile_vod__c
      ),
      reportProfileNameFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Profile_Name_vod__c
      ),
      reportORTIdFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Object_RecordType_Id_vod__c
      ),
      reportORTNameFLS: this.findFieldFLS(
        objectDescribe[QUERIES.htmlReport.object],
        HTML_REPORT_FIELD_NAMES.Object_RecordType_vod__c
      ),
      phoneFLS: this.findFieldFLS(
        objectDescribe[QUERIES.htmlReport.object],
        HTML_REPORT_FIELD_NAMES.Phone_vod__c
      ),
      studioVersionFLS: this.findFieldFLS(
        objectDescribe[QUERIES.htmlReport.object],
        HTML_REPORT_FIELD_NAMES.Studio_Version_vod__c
      ),
      studioIdFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Studio_Id_vod__c
      ),
      nameFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Name
      ),
      recordTypeFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.RecordType
      ),
      externalIdFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.External_Id_vod__c
      ),
      visibilityCriteriaFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Visibility_Criteria_vod__c
      ),
      sharingGroupFLS: this.findFieldFLS(
        objectDescribe[objName],
        HTML_REPORT_FIELD_NAMES.Sharing_Group_vod__c
      )
    };
  },
  getDeployTableFieldList(FLSObject, htmlReportFieldLabels) {
    let invalidFields = [];

    if (!FLSObject.reportProfileNameFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Profile_Name_vod__c);
    }

    if (!FLSObject.reportORTNameFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Object_RecordType_vod__c);
    }

    if (!FLSObject.phoneFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Phone_vod__c);
    }

    if (!FLSObject.platformFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Platform_vod__c);
    }

    if (!FLSObject.statusFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Status_vod__c);
    }

    if (!FLSObject.statusDetailsFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Failure_Msg_vod__c);
    }

    if (!FLSObject.studioVersionFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Studio_Version_vod__c);
    }

    if (!FLSObject.nameFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Name);
    }

    if (!FLSObject.recordTypeFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.RecordType);
    }

    if (!FLSObject.externalIdFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.External_Id_vod__c);
    }

    if (!FLSObject.visibilityCriteriaFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Visibility_Criteria_vod__c);
    }

    if (!FLSObject.sharingGroupFLS.hasRead) {
      invalidFields.push(HTML_REPORT_FIELD_NAMES.Sharing_Group_vod__c);
    }

    return htmlReportFieldLabels.filter(
      field => !invalidFields.includes(field.key)
    );
  },
  mergeMetadata(target, metadata) {
    target.uuid = metadata.uuid;
    target.sourceTemplateUuid = metadata.sourceTemplateUuid;
    target.sourceTemplateVersion = metadata.sourceTemplateVersion;
    target.isTemplate = metadata.isTemplate;
    target.version = metadata.version;
    target.description = metadata.description;
    target.customContent = metadata.customContent;
  },
  validateName(input, currentDeId, dataElements) {
    if (!input) {
      return false;
    }

    let result;

    if (dataElements) {
      const existing = Object.keys(dataElements).find(key => {
        return (
          dataElements[key].id !== currentDeId &&
          dataElements[key].name.toLowerCase() === input.toLowerCase()
        );
      });

      result = !(existing || input.toLowerCase().includes("___"));
    } else {
      result = true;
    }

    return result;
  },
  setFieldLabels(sources, fieldOrder, des) {
    const dataElementsWithFields = new Map(
      expressionBuilder.filterGlobalSources(des).map(elm => [elm.id, elm])
    );
    const fieldLabels = [];
    if (
      sources !== undefined &&
      sources.length !== 0 &&
      fieldOrder !== undefined
    ) {
      fieldOrder.forEach((field, index) => {
        fieldLabels.push({ label: field.label, fieldType: field.fieldType });
        fieldLabels[index].fieldList = [];
        sources.forEach(source => {
          const dataElement = dataElementsWithFields.get(source.dataSource);
          let name = source.dict[field.label];
          if (dataElement && dataElement.fields[name] !== undefined) {
            let label = dataElement.fields[name].label;
            fieldLabels[index].fieldList.push({
              label: label ? label : name,
              dataType: fieldLabels[index].fieldType,
              name: name,
              isEmpty: false
            });
          } else if (dataElement && Array.isArray(dataElement.fields)) {
            // this is for data engine queries since dataElement.fields is an array and not a dict
            fieldLabels[index].fieldList.push({
              label: name,
              dataType: fieldLabels[index].fieldType,
              name: name,
              isEmpty: false
            });
          } else {
            fieldLabels[index].fieldList.push({
              isEmpty: true
            });
          }
        });
      });
    }
    return fieldLabels;
  },
  isExpressionWhiteSpace(expression) {
    if (expression && typeof expression.value === STUDIO_DATA_TYPE.STRING) {
      return expression.value.trim() === "";
    }
    return false;
  },
  getSalesDataQueryFields() {
    return [
      {
        label: i18n.t("Account_Id_vod__c"),
        name: "Account_Id_vod__c",
        dataType: "string"
      },
      {
        label: i18n.t("id"),
        name: "ID_vod__c",
        dataType: "string"
      },
      {
        label: mixin.methods.getMessageText(store.state.messages.MARKET),
        name: "Market_vod__c",
        dataType: "string"
      },
      {
        label: i18n.t("Market_Id_vod__c"),
        name: "Market_Id_vod__c",
        dataType: "string"
      },
      {
        label: i18n.t("Product_Group_vod__c"),
        name: "Product_Group_vod__c",
        dataType: "string"
      },
      {
        label: i18n.t("Product_Group_Id_vod__c"),
        name: "Product_Group_Id_vod__c",
        dataType: "string"
      },
      {
        label: mixin.methods.getMessageText(store.state.messages.SALES_DATE),
        name: "Sales_Date_vod__c",
        dataType: "date"
      },
      {
        label: mixin.methods.getMessageText(store.state.messages.SALES_DATA),
        name: "Sales_Data_vod__c",
        dataType: "number"
      }
    ];
  },
  getCallAttendeesFields() {
    return [
      {
        label: i18n.t("accountId"),
        name: "Account ID",
        dataType: "string"
      }
    ];
  },
  getAlignedTerritoriesFields() {
    return [
      {
        label: i18n.t("name"),
        name: "name",
        dataType: "string"
      },
      {
        label: i18n.t("id"),
        name: "id",
        dataType: "string"
      },
      {
        label: i18n.t("description"),
        name: "description",
        dataType: "string"
      },
      {
        label: i18n.t("developerName"),
        name: "developerName",
        dataType: "string"
      },
      {
        label: i18n.t("parentTerritoryId"),
        name: "parentTerritoryId",
        dataType: "string"
      }
    ];
  },
  prepareDimensionsAndMetrics() {
    let dimensions = CRM_DATA_ENGINE_DIMENSIONS.map(d => {
      d.name = i18n.t(d.type.toLowerCase());
      return d;
    });

    let metrics = CRM_DATA_ENGINE_METRICS.map(d => {
      d.name = i18n.t(d.type.toLowerCase());
      return d;
    });

    return dimensions.concat(metrics);
  },
  isValidAction(action) {
    if (action && action.navigation) {
      const nav = action.navigation;
      if (nav.type === NAVIGATION_ACTIONS.VIEW_RECORD) {
        return nav.type && nav.recordId;
      } else {
        return (
          nav.type &&
          nav.target &&
          nav.target.length > 0 &&
          !nav.target.some(e => e.Studio_Id_vod__c === undefined)
        );
      }
    }
    return !action;
  }
};
